import { EncryptStorage } from 'encrypt-storage'

const encryptStorage = new EncryptStorage('app-storage-safety', {
    prefix: 'sec',
})

export default encryptStorage
